import { Checkbox } from "@progress/kendo-react-inputs";
import { useFetchedValues } from "../../../../../Hooks/Display/useComponentProperties";

function ColorFormatting({ dataItem, onChange }) {
    const handleChange = (event) => {
        onChange(event, dataItem);
    };

    const [fetchedValues] = useFetchedValues();
    const attributes = fetchedValues?.attributeTable?.attributes || [];
    const currentAttribute = attributes.find(attribute => attribute._id === dataItem.attributeId);

    if (!currentAttribute) {
        return <td></td>;
    }

    const isNumberOrPicklistString = currentAttribute.attributeType === "Number" || currentAttribute.attributeType === "Picklist String";
    const isMirrorWithNumberOrPicklistString = currentAttribute.attributeType === "Mirror" &&
        currentAttribute.attribute &&
        (currentAttribute.attribute.attributeType === "Number" || currentAttribute.attribute.attributeType === "Picklist String");

    if (isNumberOrPicklistString || isMirrorWithNumberOrPicklistString) {
        return (
            <td>
                <Checkbox
                    onChange={handleChange}
                    checked={dataItem.cellRules}
                />
            </td>
        );
    }

    return <td></td>;
}

export default ColorFormatting;
